// AUTO-GENERATED — do not edit manually
// Source: client-deliverables/icon-migration-review/sections.json + icon-migration-batch-*.json
// Run: node generate-icon-registry.js

import React from 'react';

import { ReactComponent as AbstractAbstract25 } from '../../../assets/icons/abstract/abstract-25.svg';
import { ReactComponent as AbstractAbstract5 } from '../../../assets/icons/abstract/abstract-5.svg';
import { ReactComponent as ArrowsArrowRight } from '../../../assets/icons/arrows/arrow-right.svg';
import { ReactComponent as ArrowsArrowUp } from '../../../assets/icons/arrows/arrow-up.svg';
import { ReactComponent as ArrowsArrowUpRefraction } from '../../../assets/icons/arrows/arrow-up-refraction.svg';
import { ReactComponent as ArrowsBlackDown } from '../../../assets/icons/arrows/black-down.svg';
import { ReactComponent as ArrowsBlackUp } from '../../../assets/icons/arrows/black-up.svg';
import { ReactComponent as ArrowsCheck } from '../../../assets/icons/arrows/check.svg';
import { ReactComponent as ArrowsCheckCircle } from '../../../assets/icons/arrows/check-circle.svg';
import { ReactComponent as ArrowsCross } from '../../../assets/icons/arrows/cross.svg';
import { ReactComponent as ArrowsCrossCircle } from '../../../assets/icons/arrows/cross-circle.svg';
import { ReactComponent as ArrowsDotsHorizontal } from '../../../assets/icons/arrows/dots-horizontal.svg';
import { ReactComponent as ArrowsDotsVertical2 } from '../../../assets/icons/arrows/dots-vertical-2.svg';
import { ReactComponent as ArrowsDoubleCheck } from '../../../assets/icons/arrows/double-check.svg';
import { ReactComponent as ArrowsDoubleLeft } from '../../../assets/icons/arrows/double-left.svg';
import { ReactComponent as ArrowsDoubleRight } from '../../../assets/icons/arrows/double-right.svg';
import { ReactComponent as ArrowsDown } from '../../../assets/icons/arrows/down.svg';
import { ReactComponent as ArrowsEntranceLeft } from '../../../assets/icons/arrows/entrance-left.svg';
import { ReactComponent as ArrowsExitDown } from '../../../assets/icons/arrows/exit-down.svg';
import { ReactComponent as ArrowsExitUp } from '../../../assets/icons/arrows/exit-up.svg';
import { ReactComponent as ArrowsLeft } from '../../../assets/icons/arrows/left.svg';
import { ReactComponent as ArrowsLeftSquare } from '../../../assets/icons/arrows/left-square.svg';
import { ReactComponent as ArrowsPlus } from '../../../assets/icons/arrows/plus.svg';
import { ReactComponent as ArrowsRight } from '../../../assets/icons/arrows/right.svg';
import { ReactComponent as ArrowsRightSquare } from '../../../assets/icons/arrows/right-square.svg';
import { ReactComponent as ArrowsUp } from '../../../assets/icons/arrows/up.svg';
import { ReactComponent as BusinessChart } from '../../../assets/icons/business/chart.svg';
import { ReactComponent as BusinessChartLineUp } from '../../../assets/icons/business/chart-line-up.svg';
import { ReactComponent as BusinessChartSimple } from '../../../assets/icons/business/chart-simple.svg';
import { ReactComponent as CommunicationMessageText2 } from '../../../assets/icons/communication/message-text-2.svg';
import { ReactComponent as DesignCopy } from '../../../assets/icons/design/copy.svg';
import { ReactComponent as DesignPencil } from '../../../assets/icons/design/pencil.svg';
import { ReactComponent as DesignEdit } from '../../../assets/icons/design/edit.svg';
import { ReactComponent as DevicesPad } from '../../../assets/icons/devices/pad.svg';
import { ReactComponent as DevicesPhone } from '../../../assets/icons/devices/phone.svg';
import { ReactComponent as DevicesScreen } from '../../../assets/icons/devices/screen.svg';
import { ReactComponent as DevicesWifi } from '../../../assets/icons/devices/wifi.svg';
import { ReactComponent as ECommerceBasket } from '../../../assets/icons/eCommerce/basket.svg';
import { ReactComponent as ECommerceCheque } from '../../../assets/icons/eCommerce/cheque.svg';
import { ReactComponent as ECommerceLotsShopping } from '../../../assets/icons/eCommerce/lots-shopping.svg';
import { ReactComponent as ECommercePurchase } from '../../../assets/icons/eCommerce/purchase.svg';
import { ReactComponent as ECommerceShop } from '../../../assets/icons/eCommerce/shop.svg';
import { ReactComponent as EducationBookmark } from '../../../assets/icons/education/bookmark.svg';
import { ReactComponent as EducationBriefcase } from '../../../assets/icons/education/briefcase.svg';
import { ReactComponent as FilesDocument } from '../../../assets/icons/files/document.svg';
import { ReactComponent as FilesFileUp } from '../../../assets/icons/files/file-up.svg';
import { ReactComponent as FinanceBank } from '../../../assets/icons/finance/bank.svg';
import { ReactComponent as FinanceBill } from '../../../assets/icons/finance/bill.svg';
import { ReactComponent as FinanceCoin } from '../../../assets/icons/finance/coin.svg';
import { ReactComponent as FinanceDollar } from '../../../assets/icons/finance/dollar.svg';
import { ReactComponent as FinanceOfficeBag } from '../../../assets/icons/finance/office-bag.svg';
import { ReactComponent as FinanceWallet } from '../../../assets/icons/finance/wallet.svg';
import { ReactComponent as GeneralChrome } from '../../../assets/icons/general/chrome.svg';
import { ReactComponent as GeneralCloudChange } from '../../../assets/icons/general/cloud-change.svg';
import { ReactComponent as GeneralCoffee } from '../../../assets/icons/general/coffee.svg';
import { ReactComponent as GeneralCrown2 } from '../../../assets/icons/general/crown-2.svg';
import { ReactComponent as GeneralCup } from '../../../assets/icons/general/cup.svg';
import { ReactComponent as GeneralFilter } from '../../../assets/icons/general/filter.svg';
import { ReactComponent as GeneralGift } from '../../../assets/icons/general/gift.svg';
import { ReactComponent as GeneralMagnifier } from '../../../assets/icons/general/magnifier.svg';
import { ReactComponent as GeneralPicture } from '../../../assets/icons/general/picture.svg';
import { ReactComponent as GeneralShare } from '../../../assets/icons/general/share.svg';
import { ReactComponent as GeneralTrash } from '../../../assets/icons/general/trash.svg';
import { ReactComponent as GeneralWool } from '../../../assets/icons/general/wool.svg';
import { ReactComponent as GridElement11 } from '../../../assets/icons/grid/element-11.svg';
import { ReactComponent as GridElement3 } from '../../../assets/icons/grid/element-3.svg';
import { ReactComponent as GridRowHorizontal } from '../../../assets/icons/grid/row-horizontal.svg';
import { ReactComponent as LocationFlag } from '../../../assets/icons/location/flag.svg';
import { ReactComponent as LocationFocus } from '../../../assets/icons/location/focus.svg';
import { ReactComponent as LocationRoute } from '../../../assets/icons/location/route.svg';
import { ReactComponent as LogisticsCar } from '../../../assets/icons/logistics/car.svg';
import { ReactComponent as LogisticsDelivery } from '../../../assets/icons/logistics/delivery.svg';
import { ReactComponent as LogisticsParcel } from '../../../assets/icons/logistics/parcel.svg';
import { ReactComponent as MenuBurgerMenu } from '../../../assets/icons/menu/burger-menu.svg';
import { ReactComponent as MenuBurgerMenu7 } from '../../../assets/icons/menu/burger-menu-7.svg';
import { ReactComponent as NetworkFasten } from '../../../assets/icons/network/fasten.svg';
import { ReactComponent as NewFallbacksArrowTurnDownRight } from '../../../assets/icons/new/fallbacks/arrow-turn-down-right.svg';
import { ReactComponent as NewFallbacksArrows } from '../../../assets/icons/new/fallbacks/arrows.svg';
import { ReactComponent as NewFallbacksAttribute } from '../../../assets/icons/new/fallbacks/attribute.svg';
import { ReactComponent as NewFallbacksAwaitingDocument } from '../../../assets/icons/new/fallbacks/AWAITING_DOCUMENT.svg';
import { ReactComponent as NewFallbacksBattery } from '../../../assets/icons/new/fallbacks/Battery.svg';
import { ReactComponent as NewFallbacksCellularConnection } from '../../../assets/icons/new/fallbacks/CellularConnection.svg';
import { ReactComponent as NewFallbacksClassicIcon } from '../../../assets/icons/new/fallbacks/classic_icon.svg';
import { ReactComponent as NewFallbacksCom010 } from '../../../assets/icons/new/fallbacks/com010.svg';
import { ReactComponent as NewFallbacksCustomerRequested } from '../../../assets/icons/new/fallbacks/CUSTOMER_REQUESTED.svg';
import { ReactComponent as NewFallbacksDownClick } from '../../../assets/icons/new/fallbacks/down-click.svg';
import { ReactComponent as NewFallbacksDrag } from '../../../assets/icons/new/fallbacks/drag.svg';
import { ReactComponent as NewFallbacksEngineWarning } from '../../../assets/icons/new/fallbacks/engine-warning.svg';
import { ReactComponent as NewFallbacksFil024 } from '../../../assets/icons/new/fallbacks/fil024.svg';
import { ReactComponent as NewFallbacksGen022 } from '../../../assets/icons/new/fallbacks/gen022.svg';
import { ReactComponent as NewFallbacksLine59 } from '../../../assets/icons/new/fallbacks/Line59.svg';
import { ReactComponent as NewFallbacksOverdueBalance } from '../../../assets/icons/new/fallbacks/OVERDUE_BALANCE.svg';
import { ReactComponent as NewFallbacksVariantChips } from '../../../assets/icons/new/fallbacks/variant-chips.svg';
import { ReactComponent as NewFallbacksWarning } from '../../../assets/icons/new/fallbacks/warning.svg';
import { ReactComponent as SecurityEye } from '../../../assets/icons/security/eye.svg';
import { ReactComponent as SettingsSetting2 } from '../../../assets/icons/settings/setting-2.svg';
import { ReactComponent as SettingsSetting4 } from '../../../assets/icons/settings/setting-4.svg';
import { ReactComponent as SocialMediaWhatsapp } from '../../../assets/icons/social_media/whatsapp.svg';
import { ReactComponent as SupportInformation1 } from '../../../assets/icons/support/information-1.svg';
import { ReactComponent as SupportInformation2 } from '../../../assets/icons/support/information-2.svg';
import { ReactComponent as SupportLike } from '../../../assets/icons/support/like.svg';
import { ReactComponent as TechnologiesTechnology2 } from '../../../assets/icons/technologies/technology-2.svg';
import { ReactComponent as TimeCalendar } from '../../../assets/icons/time/calendar.svg';
import { ReactComponent as TimeTime } from '../../../assets/icons/time/time.svg';
import { ReactComponent as TimeTimer } from '../../../assets/icons/time/timer.svg';
import { ReactComponent as TypographyTextalignJustifycenter } from '../../../assets/icons/typography/textalign-justifycenter.svg';
import { ReactComponent as UsersProfileCircle } from '../../../assets/icons/users/profile-circle.svg';
import { ReactComponent as UsersUsers } from '../../../assets/icons/users/users.svg';
import { ReactComponent as WeatherMoon } from '../../../assets/icons/weather/moon.svg';
import { ReactComponent as WeatherSun } from '../../../assets/icons/weather/sun.svg';

/** Keys are new normalized asset paths (no .svg, no /media/ prefix). */
export const ICON_COMPONENTS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
	'abstract/abstract-25': AbstractAbstract25,
	'abstract/abstract-5': AbstractAbstract5,
	'arrows/arrow-right': ArrowsArrowRight,
	'arrows/arrow-up': ArrowsArrowUp,
	'arrows/arrow-up-refraction': ArrowsArrowUpRefraction,
	'arrows/black-down': ArrowsBlackDown,
	'arrows/black-up': ArrowsBlackUp,
	'arrows/check': ArrowsCheck,
	'arrows/check-circle': ArrowsCheckCircle,
	'arrows/cross': ArrowsCross,
	'arrows/cross-circle': ArrowsCrossCircle,
	'arrows/dots-horizontal': ArrowsDotsHorizontal,
	'arrows/dots-vertical-2': ArrowsDotsVertical2,
	'arrows/double-check': ArrowsDoubleCheck,
	'arrows/double-left': ArrowsDoubleLeft,
	'arrows/double-right': ArrowsDoubleRight,
	'arrows/down': ArrowsDown,
	'arrows/entrance-left': ArrowsEntranceLeft,
	'arrows/exit-down': ArrowsExitDown,
	'arrows/exit-up': ArrowsExitUp,
	'arrows/left': ArrowsLeft,
	'arrows/left-square': ArrowsLeftSquare,
	'arrows/plus': ArrowsPlus,
	'arrows/right': ArrowsRight,
	'arrows/right-square': ArrowsRightSquare,
	'arrows/up': ArrowsUp,
	'business/chart': BusinessChart,
	'business/chart-line-up': BusinessChartLineUp,
	'business/chart-simple': BusinessChartSimple,
	'communication/message-text-2': CommunicationMessageText2,
	'design/copy': DesignCopy,
	'design/pencil': DesignPencil,
	'design/edit': DesignEdit,
	'devices/pad': DevicesPad,
	'devices/phone': DevicesPhone,
	'devices/screen': DevicesScreen,
	'devices/wifi': DevicesWifi,
	'eCommerce/basket': ECommerceBasket,
	'eCommerce/cheque': ECommerceCheque,
	'eCommerce/lots-shopping': ECommerceLotsShopping,
	'eCommerce/purchase': ECommercePurchase,
	'eCommerce/shop': ECommerceShop,
	'education/bookmark': EducationBookmark,
	'education/briefcase': EducationBriefcase,
	'files/document': FilesDocument,
	'files/file-up': FilesFileUp,
	'finance/bank': FinanceBank,
	'finance/bill': FinanceBill,
	'finance/coin': FinanceCoin,
	'finance/dollar': FinanceDollar,
	'finance/office-bag': FinanceOfficeBag,
	'finance/wallet': FinanceWallet,
	'general/chrome': GeneralChrome,
	'general/cloud-change': GeneralCloudChange,
	'general/coffee': GeneralCoffee,
	'general/crown-2': GeneralCrown2,
	'general/cup': GeneralCup,
	'general/filter': GeneralFilter,
	'general/gift': GeneralGift,
	'general/magnifier': GeneralMagnifier,
	'general/picture': GeneralPicture,
	'general/share': GeneralShare,
	'general/trash': GeneralTrash,
	'general/wool': GeneralWool,
	'grid/element-11': GridElement11,
	'grid/element-3': GridElement3,
	'grid/row-horizontal': GridRowHorizontal,
	'location/flag': LocationFlag,
	'location/focus': LocationFocus,
	'location/route': LocationRoute,
	'logistics/car': LogisticsCar,
	'logistics/delivery': LogisticsDelivery,
	'logistics/parcel': LogisticsParcel,
	'menu/burger-menu': MenuBurgerMenu,
	'menu/burger-menu-7': MenuBurgerMenu7,
	'network/fasten': NetworkFasten,
	'new/fallbacks/AWAITING_DOCUMENT': NewFallbacksAwaitingDocument,
	'new/fallbacks/Battery': NewFallbacksBattery,
	'new/fallbacks/CUSTOMER_REQUESTED': NewFallbacksCustomerRequested,
	'new/fallbacks/CellularConnection': NewFallbacksCellularConnection,
	'new/fallbacks/Line59': NewFallbacksLine59,
	'new/fallbacks/OVERDUE_BALANCE': NewFallbacksOverdueBalance,
	'new/fallbacks/arrow-turn-down-right': NewFallbacksArrowTurnDownRight,
	'new/fallbacks/arrows': NewFallbacksArrows,
	'new/fallbacks/attribute': NewFallbacksAttribute,
	'new/fallbacks/classic_icon': NewFallbacksClassicIcon,
	'new/fallbacks/com010': NewFallbacksCom010,
	'new/fallbacks/down-click': NewFallbacksDownClick,
	'new/fallbacks/drag': NewFallbacksDrag,
	'new/fallbacks/engine-warning': NewFallbacksEngineWarning,
	'new/fallbacks/fil024': NewFallbacksFil024,
	'new/fallbacks/gen022': NewFallbacksGen022,
	'new/fallbacks/variant-chips': NewFallbacksVariantChips,
	'new/fallbacks/warning': NewFallbacksWarning,
	'security/eye': SecurityEye,
	'settings/setting-2': SettingsSetting2,
	'settings/setting-4': SettingsSetting4,
	'social_media/whatsapp': SocialMediaWhatsapp,
	'support/information-1': SupportInformation1,
	'support/information-2': SupportInformation2,
	'support/like': SupportLike,
	'technologies/technology-2': TechnologiesTechnology2,
	'time/calendar': TimeCalendar,
	'time/time': TimeTime,
	'time/timer': TimeTimer,
	'typography/textalign-justifycenter': TypographyTextalignJustifycenter,
	'users/profile-circle': UsersProfileCircle,
	'users/users': UsersUsers,
	'weather/moon': WeatherMoon,
	'weather/sun': WeatherSun
};

/** Legacy public/duotune path key (e.g. 'duotune/ecommerce/settings.svg') -> new asset path. For Icon path= fallback and migration tooling. */
export const LEGACY_ICON_PATH_TO_NEW_KEY: Record<string, string> = {
	'dashboard/Frame-blue.svg': 'arrows/entrance-left',
	'dashboard/Options_Button.svg': 'menu/burger-menu',
	'dashboard/warning.svg': 'new/fallbacks/warning',
	'duotune/arrows/Checkicon.svg': 'arrows/check',
	'duotune/arrows/Line59.svg': 'new/fallbacks/Line59',
	'duotune/arrows/Trash.svg': 'general/trash',
	'duotune/arrows/add.svg': 'arrows/plus',
	'duotune/arrows/arr012.svg': 'arrows/check',
	'duotune/arrows/arr022.svg': 'arrows/left',
	'duotune/arrows/arr023.svg': 'arrows/right',
	'duotune/arrows/arr056.svg': 'arrows/arrow-up-refraction',
	'duotune/arrows/arr061.svg': 'arrows/cross',
	'duotune/arrows/arr062.svg': 'arrows/black-up',
	'duotune/arrows/arr064.svg': 'arrows/arrow-right',
	'duotune/arrows/arr066.svg': 'arrows/arrow-up',
	'duotune/arrows/arr068.svg': 'arrows/black-down',
	'duotune/arrows/arr072.svg': 'arrows/down',
	'duotune/arrows/arr073.svg': 'arrows/up',
	'duotune/arrows/arr076.svg': 'arrows/entrance-left',
	'duotune/arrows/arr078.svg': 'arrows/exit-up',
	'duotune/arrows/arr079.svg': 'arrows/double-left',
	'duotune/arrows/arr080.svg': 'arrows/double-right',
	'duotune/arrows/arr084.svg': 'arrows/double-check',
	'duotune/arrows/arr087.svg': 'arrows/plus',
	'duotune/arrows/arr091.svg': 'arrows/exit-down',
	'duotune/arrows/arr096.svg': 'arrows/exit-up',
	'duotune/arrows/arrows.svg': 'new/fallbacks/arrows',
	'duotune/arrows/checkbox.svg': 'arrows/check-circle',
	'duotune/arrows/closeicon.svg': 'arrows/cross',
	'duotune/arrows/crossicon.svg': 'arrows/cross-circle',
	'duotune/arrows/down-click.svg': 'new/fallbacks/down-click',
	'duotune/arrows/eye_icon.svg': 'security/eye',
	'duotune/arrows/left-arrow.svg': 'arrows/left-square',
	'duotune/arrows/plus.svg': 'arrows/plus',
	'duotune/arrows/right-arrow.svg': 'arrows/right-square',
	'duotune/arrows/tableaccess.svg': 'arrows/entrance-left',
	'duotune/arrows/uploadicon.svg': 'arrows/exit-up',
	'duotune/art/dashbord.svg': 'grid/element-11',
	'duotune/art/variant-chips.svg': 'new/fallbacks/variant-chips',
	'duotune/communication/com006.svg': 'users/profile-circle',
	'duotune/communication/com010.svg': 'new/fallbacks/com010',
	'duotune/communication/com012.svg': 'communication/message-text-2',
	'duotune/communication/link.svg': 'network/fasten',
	'duotune/ecommerce/Tax2.svg': 'finance/bill',
	'duotune/ecommerce/category.svg': 'grid/element-3',
	'duotune/ecommerce/catlog.svg': 'eCommerce/lots-shopping',
	'duotune/ecommerce/close-menu.svg': 'arrows/double-left',
	'duotune/ecommerce/customer.svg': 'education/briefcase',
	'duotune/ecommerce/customerIcon.svg': 'eCommerce/shop',
	'duotune/ecommerce/datasheet.svg': 'time/calendar',
	'duotune/ecommerce/ecm002.svg': 'eCommerce/basket',
	'duotune/ecommerce/ecm006.svg': 'logistics/delivery',
	'duotune/ecommerce/images.svg': 'general/picture',
	'duotune/ecommerce/inventory.svg': 'logistics/parcel',
	'duotune/ecommerce/marketing.svg': 'business/chart',
	'duotune/ecommerce/orders.svg': 'eCommerce/purchase',
	'duotune/ecommerce/settings.svg': 'settings/setting-2',
	'duotune/ecommerce/shipping.svg': 'logistics/delivery',
	'duotune/ecommerce/users.svg': 'users/users',
	'duotune/electronics/Battery.svg': 'new/fallbacks/Battery',
	'duotune/electronics/CellularConnection.svg': 'new/fallbacks/CellularConnection',
	'duotune/electronics/Wifi.svg': 'devices/wifi',
	'duotune/electronics/elc003.svg': 'devices/pad',
	'duotune/electronics/elc004.svg': 'devices/screen',
	'duotune/electronics/mobile.svg': 'devices/phone',
	'duotune/files/fil023.svg': 'general/cloud-change',
	'duotune/files/fil024.svg': 'new/fallbacks/fil024',
	'duotune/files/fil026.svg': 'files/file-up',
	'duotune/finance/coin.svg': 'finance/coin',
	'duotune/finance/fin001.svg': 'finance/bank',
	'duotune/finance/fin006.svg': 'finance/office-bag',
	'duotune/finance/fin008.svg': 'finance/wallet',
	'duotune/finance/fin011.svg': 'general/cup',
	'duotune/general/3dot.svg': 'arrows/dots-horizontal',
	'duotune/general/AWAITING_DOCUMENT.svg': 'new/fallbacks/AWAITING_DOCUMENT',
	'duotune/general/ButtonTrash.svg': 'general/trash',
	'duotune/general/CUSTOMER_REQUESTED.svg': 'new/fallbacks/CUSTOMER_REQUESTED',
	'duotune/general/Localizationicon.svg': 'general/wool',
	'duotune/general/Menu.svg': 'typography/textalign-justifycenter',
	'duotune/general/OVERDUE_BALANCE.svg': 'new/fallbacks/OVERDUE_BALANCE',
	'duotune/general/PenIcon.svg': 'design/pencil',
	'duotune/general/Tenants.svg': 'eCommerce/cheque',
	'duotune/general/abs015.svg': 'menu/burger-menu-7',
	'duotune/general/approved.svg': 'support/like',
	'duotune/general/arrow-turn-down-right.svg': 'new/fallbacks/arrow-turn-down-right',
	'duotune/general/attribute.svg': 'new/fallbacks/attribute',
	'duotune/general/attributeSet.svg': 'abstract/abstract-25',
	'duotune/general/classic_icon.svg': 'new/fallbacks/classic_icon',
	'duotune/general/copy_icon.svg': 'design/copy',
	'duotune/general/crown_icon.svg': 'general/crown-2',
	'duotune/general/drag.svg': 'new/fallbacks/drag',
	'duotune/general/drag2.svg': 'arrows/dots-vertical-2',
	'duotune/general/engine-warning.svg': 'new/fallbacks/engine-warning',
	'duotune/general/gen005.svg': 'files/document',
	'duotune/general/gen006.svg': 'general/picture',
	'duotune/general/gen013.svg': 'time/time',
	'duotune/general/gen019.svg': 'settings/setting-4',
	'duotune/general/gen021.svg': 'general/magnifier',
	'duotune/general/gen022.svg': 'new/fallbacks/gen022',
	'duotune/general/gen027.svg': 'general/trash',
	'duotune/general/gen031.svg': 'general/filter',
	'duotune/general/gen032.svg': 'business/chart-simple',
	'duotune/general/gen044.svg': 'support/information-1',
	'duotune/general/gen045.svg': 'support/information-2',
	'duotune/general/gen055.svg': 'design/pencil',
	'duotune/general/gen056.svg': 'education/bookmark',
	'duotune/general/gen060.svg': 'weather/sun',
	'duotune/general/gen061.svg': 'weather/moon',
	'duotune/general/gen062.svg': 'devices/screen',
	'duotune/general/gift.svg': 'general/gift',
	'duotune/general/settingsIcon.svg': 'settings/setting-2',
	'duotune/general/systemusersicon.svg': 'users/users',
	'duotune/general/time.svg': 'time/time',
	'duotune/general/TenentProfileicon.svg': 'eCommerce/cheque',
	'duotune/general/Usage - Customers.svg': 'eCommerce/shop',
	'duotune/general/Usage - Products.svg': 'eCommerce/lots-shopping',
	'duotune/general/Usage - Storage.svg': 'grid/row-horizontal',
	'duotune/general/Usage - Users.svg': 'users/users',
	'duotune/graphs/gra001.svg': 'business/chart-simple',
	'duotune/graphs/gra002.svg': 'business/chart-line-up',
	'duotune/layouts/lay004.svg': 'grid/element-3',
	'duotune/maps/car-2.svg': 'logistics/car',
	'duotune/maps/coffee.svg': 'general/coffee',
	'duotune/maps/focus.svg': 'location/focus',
	'duotune/maps/map001.svg': 'location/flag',
	'duotune/maps/map003.svg': 'location/route',
	'duotune/maps/time.svg': 'time/timer',
	'duotune/social/share1.svg': 'general/share',
	'duotune/social/soc011.svg': 'general/chrome',
	'duotune/social/whatsapp.svg': 'social_media/whatsapp',
	'duotune/technology/teh008.svg': 'technologies/technology-2'
};
